<template>
  <div class="order-progress">
    <!-- <div v-show="currStatus === 'draft'" class="noData"> 暂未数据 </div> -->
    <!-- <div
      v-show="currStatus !== 'draft'"
      v-for="(data, index) in listData"
      :key="index"
      class="item-progress"
    > -->
    <div
      v-show="currStatus !== 'draft'"
      v-for="(data, index) in listData"
      :key="index"
      class="item-progress"
    >
      <div class="progress-strip">
        <div :class="data.isComplete ? 'circle-active' : 'circle-default'"></div>
        <div :class="data.isComplete ? 'line-active' : 'line-default'"></div>
      </div>
      <div class="progress-info">
        <div class="status-info">
          <span :class="data.isComplete ? 'service-name' : 'default-name'">{{
            data.serviceName
          }}</span>
          <span style="margin-left: 14px">{{ data.serviceStatus || '' }}</span>
        </div>
        <div class="date-info">
          <div v-show="data.startTime">开始时间: {{ data.startTime }}</div>
          <div v-show="data.completeTime">完成时间: {{ data.completeTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'orderProgress',
    props: ['currStatus', 'listData'],
    data() {
      return {};
    },
    methods: {
      getTargetData(arr) {
        this.listData = arr;
      },
    },
    watch: {
      listData(newVal) {
        if (newVal) {
          this.getTargetData(newVal);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .order-progress {
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 100%;
    .noData {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .item-progress {
      display: flex;
      flex-direction: column;
      width: 200px;
      height: 100%;
      .progress-strip {
        margin-top: 16px;
        width: 200px;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 20px;
        line-height: 20px;
        .circle-active {
          width: 12px;
          height: 12px;
          background-color: #1890ff;
          border-radius: 50%;
        }
        .circle-default {
          width: 12px;
          height: 12px;
          background-color: #b9bdc0;
          border-radius: 50%;
        }
        .line-active {
          width: 188px;
          height: 4px;
          background-color: #1890ff;
        }
        .line-default {
          width: 188px;
          height: 4px;
          background-color: #b9bdc0;
        }
      }
      .progress-info {
        display: flex;
        flex-direction: column;
        .status-info {
          margin-top: 10px;
          .service-name {
            color: #000;
          }
          .default-name {
            color: #b9bdc0;
          }
        }
        .date-info {
          margin-top: 10px;
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
</style>
